import { useState } from "react";
import { toast } from "sonner";
import { Undo2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function ReturnSettingsCard() {
  const { session } = useAuth();
  const b = session.business;
  const [f, setF] = useState({ return_days: String(b.return_days ?? 14), cn_valid_days: String(b.cn_valid_days ?? 90) });
  const [error, setError] = useState("");
  const save = async () => {
    setError("");
    const body = { return_days: parseInt(f.return_days, 10), cn_valid_days: parseInt(f.cn_valid_days, 10) };
    if (!(body.return_days >= 1 && body.return_days <= 365) || !(body.cn_valid_days >= 1 && body.cn_valid_days <= 3650)) return setError("Enter a valid number of days");
    try {
      await api.put("/settings/returns", body);
      toast.success("Return settings saved");
      window.dispatchEvent(new Event("session-stale"));
    } catch (ex) {
      setError(errMsg(ex));
    }
  };
  const inp = "h-11 w-24 rounded-xl border border-slate-200 px-3 text-right font-mono";
  return (
    <div className="mt-6 flex flex-wrap items-center gap-4 rounded-2xl border border-slate-200 bg-white p-5" data-testid="settings-returns-card">
      <div className="grid h-11 w-11 place-items-center rounded-xl bg-slate-950 text-amber-400"><Undo2 className="h-5 w-5" /></div>
      <div className="min-w-[200px] flex-1"><div className="font-semibold text-slate-900">Returns</div><p className="text-sm text-slate-500">How long customers can return items, and how long credit notes stay valid.</p></div>
      <label className="flex items-center gap-2 text-sm font-semibold">Return period <input className={inp} value={f.return_days} onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), save())} onChange={(e) => setF({ ...f, return_days: e.target.value })} data-testid="settings-return-days" /> days</label>
      <label className="flex items-center gap-2 text-sm font-semibold">Credit note validity <input className={inp} value={f.cn_valid_days} onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), save())} onChange={(e) => setF({ ...f, cn_valid_days: e.target.value })} data-testid="settings-cn-days" /> days</label>
      <button type="button" onClick={save} className="h-11 rounded-xl bg-slate-900 px-4 text-sm font-bold text-white" data-testid="settings-returns-save">Save</button>
      {error && <div className="w-full text-sm font-semibold text-rose-600" data-testid="settings-returns-error">{error}</div>}
    </div>
  );
}
